import _createForOfIteratorHelper from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import React, { forwardRef } from 'react';
import { useComponentDefaultProps } from '@mantine/styles';
import { useModalBaseContext } from '../ModalBase.context.js';
import useStyles from './ModalBaseContent.styles.js';
import { Transition } from '../../Transition/Transition.js';
import { FocusTrap } from '../../FocusTrap/FocusTrap.js';
import { Paper } from '../../Paper/Paper.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

var defaultProps = {};
var ModalBaseContent = forwardRef(function (props, ref) {
  var ctx = useModalBaseContext();

  var _a = useComponentDefaultProps("".concat(ctx.__staticSelector, "Content"), defaultProps, props),
      className = _a.className,
      transitionProps = _a.transitionProps,
      style = _a.style,
      onKeyDown = _a.onKeyDown,
      others = __objRest(_a, ["className", "transitionProps", "style", "onKeyDown"]);

  var _useStyles = useStyles({
    zIndex: ctx.zIndex + 1
  }, ctx.stylesApi),
      classes = _useStyles.classes,
      cx = _useStyles.cx;

  var handleKeyDown = function handleKeyDown(event) {
    var _a2;

    var shouldTrigger = ((_a2 = event.target) == null ? void 0 : _a2.getAttribute("data-mantine-stop-propagation")) !== "true";
    shouldTrigger && event.key === "Escape" && ctx.closeOnEscape && ctx.onClose();
    onKeyDown == null ? void 0 : onKeyDown(event);
  };

  return /* @__PURE__ */React.createElement(Transition, __spreadValues(__spreadValues({
    mounted: ctx.opened,
    transition: "pop"
  }, ctx.transitionProps), transitionProps), function (transitionStyles) {
    return /* @__PURE__ */React.createElement("div", {
      className: cx(classes.inner)
    }, /* @__PURE__ */React.createElement(FocusTrap, {
      active: ctx.opened && ctx.trapFocus
    }, /* @__PURE__ */React.createElement(Paper, __spreadValues({
      component: "section",
      role: "dialog",
      tabIndex: -1,
      "aria-modal": true,
      "aria-describedby": ctx.bodyMounted ? ctx.getBodyId() : void 0,
      "aria-labelledby": ctx.titleMounted ? ctx.getTitleId() : void 0,
      onKeyDown: handleKeyDown,
      ref,
      className: cx(classes.content, className),
      style: __spreadValues(__spreadValues({}, style), transitionStyles),
      shadow: ctx.shadow
    }, others), others.children)));
  });
});
export { ModalBaseContent };